module.exports = __webpack_public_path__ + "static/media/Icon 1.9e2e7576.png";